import { useNavigate } from "react-router-dom";
import { TextField, Button, IconButton, InputAdornment } from "@mui/material";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showError, showToast } from "../../constants/toasts";
import { usePostChangePasswordMutation } from "../../service/auth";
import Loader from "../../constants/Loader";
import { useAppDispatch } from "../../hooks/store";
import { resetAuth } from "../../reducers/authSlice";
import { removeFromStorage, STORAGE_KEYS } from "../../helpers";

const ChangePassword = () => {
  const [changePassword, { isLoading }] = usePostChangePasswordMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => {
    setShowPassword1((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => {
    setShowPassword2((prev) => !prev);
  };
  const handleMouseDownPassword2 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
        .required("New password is required")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character."
        )
        .notOneOf(
          [Yup.ref("oldPassword")],
          "New password must be different from old password"
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        isResetPassword: false,
        oldPassword: formik.values.oldPassword,
        newPassword: formik.values.newPassword,
      };

      try {
        const response = await changePassword(body).unwrap();
        if (response?.statusCode === 200) {
          formik.resetForm();
          showToast("Password changed successfully. Please log in with your new password.");
          // Auto-logout for security after a successful password change
          dispatch(resetAuth());
          removeFromStorage(STORAGE_KEYS.token);
          removeFromStorage(STORAGE_KEYS.credentials);
          navigate("/");
        }
      } catch (error: any) {
        showError(error?.data?.message || "Something went wrong");
      }
      formik.setSubmitting(false);
    },
  });

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>Change Password</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          {/* <button onClick={() => navigate("/manage-profile")}>
            Manage Profile
          </button>{" "} */}
          Change Password
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <form onSubmit={formik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_33">
                <label htmlFor="password">Old Password</label>
                <TextField
                  placeholder="Enter Old Password"
                  fullWidth
                  hiddenLabel
                  type={showPassword ? "text" : "password"}
                  id="oldPassword"
                  name="oldPassword"
                  className="text_field"
                  value={formik.values.oldPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.oldPassword && formik.errors.oldPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="newpassword">New Password</label>
                <TextField
                  placeholder="Enter New Password"
                  hiddenLabel
                  fullWidth
                  type={showPassword1 ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  className="text_field"
                  value={formik.values.newPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.newPassword && formik.errors.newPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            showPassword1 ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword1}
                          onMouseDown={handleMouseDownPassword1}
                          edge="end"
                        >
                          {showPassword1 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="confirmpassword">Confirm New Password</label>
                <TextField
                  placeholder="Enter Confirm New Password"
                  hiddenLabel
                  fullWidth
                  type={showPassword2 ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  className="text_field"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            showPassword2 ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword2}
                          edge="end"
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className="form_btn">
              <Button type="submit" className="btn btn_primary">
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
